import { render } from "./Edit.vue?vue&type=template&id=7ecdd044&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=7ecdd044&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecdd044"]])

export default __exports__